/* eslint-disable */

//英托邦 本地
function local() {
  return {
    brand: "YXW", //品牌
    hostname: "127.0.0.1", //域名
    API_ADDRESS: "http://127.0.0.1:8443", //服务器地址
    WSS_ADDRESS: "ws://127.0.0.1:8443/myWs", //websocket服务器地址
    PRINT_ADDRESS: "http://113.250.13.197:34071", //服务器地址
    AI_ADDRESS: "http://192.168.5.212:6039", //AI服务器地址
  };
}

//英小鹉 Ai4.0
function yxw_dev() {
  return {
    brand: "YXW", //品牌
    hostname: "yxw6-admin.yingxiaowu.cn", //域名
    API_ADDRESS: "http://113.250.13.197:34070", //服务器地址
    WSS_ADDRESS: "ws://113.250.13.197:34070/myWs", //websocket服务器地址
    PRINT_ADDRESS: "http://113.250.13.197:34071", //服务器地址
    AI_ADDRESS: "http://lx-ai-server-demo.yingyutifen.cn:6039", //AI服务器地址
  };
}


//重庆新测试环境
function yxw() {
  return {
    brand: "YXW", //品牌
    hostname: "yxw6-admin.yingxiaowu.cn", //域名
    API_ADDRESS: "https://yxw6-api.yingxiaowu.cn", //服务器地址
    WSS_ADDRESS: "wss://yxw6-api.yingxiaowu.cn/myWs", //websocket服务器地址
    PRINT_ADDRESS: "https://yxw6-print.yingxiaowu.cn", //服务器地址
    AI_ADDRESS: "https://ai-api.yingyutifen.cn:8443", //AI服务器地址
  };
}

//李校来啦 Ai5.0预生产环境
function liXiao_ai5_Pre() {
  return {
    brand: "LIXIAO", //品牌
    hostname: "lx5-admin.yingyutifen.cn", //域名
    API_ADDRESS: "https://lx5-api.yingyutifen.cn", //服务器地址
    WSS_ADDRESS: "wss://lx5-api.yingyutifen.cn/myWs", //websocket服务器地址
    PRINT_ADDRESS: "http://lx5-print.yingyutifen.cn", //打印地址
    AI_ADDRESS: "https://ai-api.yingyutifen.cn:8443", //AI服务器地址
  };
}

const userAgent = navigator.userAgent;
/**
 * 判断当前设备是否是平板设备（iPad 或 Android 平板）
 * @returns {boolean} 如果是平板设备返回 true，否则返回 false
 */
function isTabletDevice() {
  const userAgent = navigator.userAgent;
  console.log(userAgent);
  return /iPad|Android/i.test(userAgent) && !/Mobile/i.test(userAgent);
}
function  IsChrome(){
  return  /^((?!Chrome|Android|Firefox).)*Safari/i.test(userAgent);
}
/**
 * 判断当前设备是否是移动设备（手机或平板）
 * @returns {boolean} 如果是移动设备返回 true，否则返回 false
 */
function isMobileDevice() {
  const userAgent = navigator.userAgent;
  return /Mobi|Android|iPhone|iPad|iPod/i.test(userAgent);
}
function getDomainName() {
  let DomainStr= location.hostname;
  if(isMobileDevice()||isTabletDevice())
  {

    if(DomainStr.includes('localhost')||DomainStr.includes('127.0.0.1'))
    {
      return process.env.VUE_APP_HOSTNAME;
    }
  }
  return DomainStr;
}
export default {
  config:{
    brand: process.env.VUE_APP_BRAND,                         //品牌
    hostname:getDomainName(),                   //域名
    API_ADDRESS: process.env.VUE_APP_API_ADDRESS,      //服务器地址
    WSS_ADDRESS: process.env.VUE_APP_WSS_ADDRESS,   //websocket服务器地址
    PRINT_ADDRESS: process.env.VUE_APP_PRINT_ADDRESS,       //服务器地址
    AI_ADDRESS:process.env.VUE_APP_AI_ADDRESS,
},
  version: "1.1.0", //APP版本
};

// export const forgetAppUrl = "https://ytb.yileifeng.com:24915";
export const forgetAppUrl = "https://yxw6-forget.yingxiaowu.cn";
export const forgetH5Url = "https://yxw6-forget.yingxiaowu.cn:30166";
